import { render, staticRenderFns } from "./dataPageArea.vue?vue&type=template&id=561e2a34&"
import script from "./dataPageArea.vue?vue&type=script&lang=js&"
export * from "./dataPageArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports